module.exports = __webpack_public_path__ + "static/img/banner_service.b1c95a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/banner_service.png
// module id = XRk9
// module chunks = 0